import { iconObj } from 'components/Menu/NewMenu/constants';
import {
  IconBox,
  StyledCategoryButton,
  StyledNavLink,
} from 'components/Menu/NewMenu/subcomponents/CategoryItem/styled';
import { TagBadge } from './styled';
import { makeEnvironmentUrl } from 'utils/development-tools';
import { Tooltip } from 'react-tooltip';

export const MenuLinkItem = ({ label, link, isExternal = false, isChildren = false, disabled, tag }) => {
  const index = new Date().getTime();

  const linkProps = {
    to: link,
  };
  const isActive = link.toLowerCase().includes(location.pathname.toLowerCase());

  const commonButtonProps = {
    isChildren,
    disabled: disabled,
    isActive,
  };

  if (isExternal || link === '') {
    return (
      <StyledCategoryButton key={label} {...commonButtonProps}>
        {isExternal ? (
          <>
            <a
              onClick={event => (disabled ? event.preventDefault() : null)}
              href={makeEnvironmentUrl(link)}
              disabled={disabled}
              data-tooltip-id={`external-${index}-${link}`}
              data-tooltip-content="Você não tem acesso a esse item."
              data-tooltip-place="top-start"
            >
              {!isChildren && <IconBox>{iconObj[label]}</IconBox>}
              <span>{label}</span>
              {tag && <TagBadge>{tag}</TagBadge>}
            </a>
            {disabled && (
              <Tooltip
                id={`external-${index}-${link}`}
                style={{ borderRadius: 10 }}
                disableTooltip={elem => elem.getAttribute('disabled')}
              />
            )}
          </>
        ) : (
          <div>
            {!isChildren && <IconBox>{iconObj[label]}</IconBox>}
            <a
              onClick={event => (disabled ? event.preventDefault() : null)}
              href={makeEnvironmentUrl(link)}
              disabled={disabled}
              data-tooltip-id={`single-${index}`}
              data-tooltip-content="Você não tem acesso a esse item."
              data-tooltip-place="top-start"
            >
              {label}
              {tag && <TagBadge>{tag}</TagBadge>}
            </a>
            {disabled && (
              <Tooltip
                id={`single-${index}`}
                style={{ borderRadius: 10 }}
                disableTooltip={elem => elem.getAttribute('disabled')}
              />
            )}
          </div>
        )}
      </StyledCategoryButton>
    );
  }

  return (
    <StyledCategoryButton key={label} {...commonButtonProps}>
      <StyledNavLink
        {...linkProps}
        onClick={event => (disabled ? event.preventDefault() : null)}
        disabled={disabled}
        data-tooltip-id={`tooltip-${index}-${link}`}
        data-tooltip-content="Você não tem acesso a esse item."
        data-tooltip-place="top-start"
      >
        {!isChildren && <IconBox>{iconObj[label]}</IconBox>}
        <span>{label}</span>
        {tag && <TagBadge>{tag}</TagBadge>}
      </StyledNavLink>
      {disabled && (
        <Tooltip
          id={`tooltip-${index}-${link}`}
          style={{ borderRadius: 10 }}
          disableTooltip={elem => elem.getAttribute('disabled')}
        />
      )}
    </StyledCategoryButton>
  );
};
